import _classCallCheck from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty";
import Status from '../status/Status';
import { initGtm } from '../gtm/GoogleTagManager';

var GTM = /*#__PURE__*/function () {
  function GTM(id, auth, preview, cookies_win, dataLayerName, dataLayer, event) {
    _classCallCheck(this, GTM);

    _defineProperty(this, "isActive", true);

    this._id = id;
    this._auth = auth;
    this._preview = preview;
    this._cookies_win = cookies_win;
    this._dataLayerName = dataLayerName;
    this._dataLayer = dataLayer;
    this._events = event;
  }

  _createClass(GTM, [{
    key: "init",
    value: function init() {
      initGtm({
        id: this._id
      });
      return new Status(this, true);
    }
  }, {
    key: "sendEvent",
    value: function sendEvent(data) {
      var _this = this;

      return new Promise(function (resolve) {
        window[_this._dataLayerName].push(Object.assign({
          event: data.event,
          eventCallback: function eventCallback() {
            resolve(new Status(_this, true));
          },
          eventTimeout: 2000
        }, data.property));
      });
    }
  }, {
    key: "id",
    get: function get() {
      return this._id;
    },
    set: function set(value) {
      this._id = value;
    }
  }, {
    key: "auth",
    get: function get() {
      return this._auth;
    },
    set: function set(value) {
      this._auth = value;
    }
  }, {
    key: "preview",
    get: function get() {
      return this._preview;
    },
    set: function set(value) {
      this._preview = value;
    }
  }, {
    key: "cookies_win",
    get: function get() {
      return this._cookies_win;
    },
    set: function set(value) {
      this._cookies_win = value;
    }
  }, {
    key: "dataLayerName",
    get: function get() {
      return this._dataLayerName;
    },
    set: function set(value) {
      this._dataLayerName = value;
    }
  }, {
    key: "dataLayer",
    get: function get() {
      return this._dataLayer;
    },
    set: function set(value) {
      this._dataLayer = value;
    }
  }, {
    key: "events",
    get: function get() {
      return this._events;
    },
    set: function set(value) {
      this._events = value;
    }
  }]);

  return GTM;
}();

export { GTM as default };